import { DefaultTheme } from 'styled-components';

// COME SI LEGGE UNA RIGA, NEI DUE ALBERI (utente, 2026-10-15; prototipo, ds.css `.row`, `.tree-block`).
// Lo Scene Editor e il Composer disegnano le righe con componenti loro, ma i segni sono questi e
// stanno qui, perché due copie dello stesso arancio divergono alla prima modifica.
//
// - LA RIGA SCELTA: fondo arancio lavato e un filo arancio intorno.
// - LE RIGHE CHE LA CONTENGONO (la «scia»): lo stesso lavato, senza filo; il glifo e la freccetta
//   prendono l'arancio. Scegliere un figlio non spegne i padri: si vede ancora dove sta.
// - LA CARD: un ramo che contiene solo foglie — un attributo e le sue opzioni, un Empty e le sue mesh —
//   è una card grigia, testata compresa, aperta o chiusa. I rami che contengono altri rami no.

/** Il lavato della riga scelta e della sua scia. */
export const treeRowWash = (theme: DefaultTheme) => `${theme.app.secondary}14`;
/** Il filo della sola riga scelta. */
export const treeRowRing = (theme: DefaultTheme) => `inset 0 0 0 1px ${theme.app.secondary}`;
/** Il glifo e la freccetta di una riga della scia. */
export const treeTrailInk = (theme: DefaultTheme) => theme.app.secondary;
/** Il fondo della card di un ramo di foglie, e quello di una riga che ci passa sopra dentro la card. */
export const TREE_CARD_BACKGROUND = '#f4f7fa';
export const TREE_CARD_HOVER = '#e9eff5';
export const TREE_CARD_RADIUS = '8px';

// LA COLONNA DELL'INSPECTOR È GRIGIA (utente, 2026-10-15; prototipo `.inspector { background: var(--bg-sunken) }`):
// testata, tab, corpo e stato vuoto. Bianche restano le card e i campi, col loro bordo; bianco resta
// l'albero. Un posto solo per i due editor.
export const INSPECTOR_BACKGROUND = '#f4f7fa';

// LA MARCA IN TESTATA ALL'INSPECTOR (prototipo `.ident-icon`): il riquadro col glifo della specie,
// grigio come la colonna e staccato da un filo. Le stesse misure nei due editor.
// Grande come la marca di un oggetto nella testata della scena (utente, 2026-10-15): 26 era poca cosa.
export const INSPECTOR_MARK_SIZE = 34;
export const INSPECTOR_MARK_GLYPH = 18;
export const INSPECTOR_MARK_RADIUS = '6px';
export const INSPECTOR_MARK_LINE = '#dbe2e6';
